import React from "react";
import styles from "Developers/LuiSanchez/assets/styles.module.scss";
import playArrow from "Developers/LuiSanchez/assets/playArrow.svg";

type MediaLinkBoxProps = {
  image: string;
  url: string;
  title: string;
};

const MediaLinkBox: React.FC<MediaLinkBoxProps> = ({ image, url, title }) => {
  return (
    <div data-testid='MediaLinkBox' className={`${styles.box}`}>
      <div data-testid='boxHeader' className={`${styles.boxHeader}`}>
        {title}
      </div>
      <a target='_blank' href={url}>
        <div title='Play' className={`${styles.glass}`}>
          <img src={playArrow} alt='play-arrow-icon' />
        </div>
      </a>
      <div>
        <img
          className={`${styles.masterpiece}`}
          src={image}
          alt='masterpiece-image'
        />
      </div>
    </div>
  );
};
export default MediaLinkBox;
